/* =========================================================================
   et-cart-empty.js - Ela Teila
   TUSCIO KREPSELIO BLOKAS: tekstai ir CTA nuoroda.

   Kraunama is snippets/et-scroll-keep.liquid (script eilute failo gale).
   GRAZINIMAS: istrinti ta <script> eilute snippete.

   KODEL JS, o ne CSS:
     nuorodos adreso (href) CSS pakeisti negali. Tema veda i /collections/all,
     o Rita nore, kad vestu i Shop All (/collections/shop-all).
     Tekstus keiciam cia pat, kad neliktu font-size:0 triuku.

   KODEL NE main-cart.liquid:
     tas failas 27 KB, o rasymo kanalas nukerta apie ties 5 KB.
   ========================================================================= */
(function () {
  function fix() {
    if (!document.documentElement.classList.contains('template--cart')) return;
    var es = document.querySelector('#main .empty-state');
    if (!es) return;

    var p = es.querySelector('p.text--large');
    if (p && /cart is empty/i.test(p.textContent)) {
      p.textContent = 'Nothing here for now.';
    }

    var a = es.querySelector('.button-wrapper a.button');
    if (a) {
      a.textContent = 'Continue shopping';
      a.setAttribute('href', '/collections/shop-all');
      a.classList.add('et-cart-cta');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
